import React, { useState, useEffect, useRef } from 'react';

type ImageProp = {
    src: string;
    className: string;
}

function Image({src, className = ""} : ImageProp){
    
    const [imgLoaded, setImageLoaded] = useState(false);
    const img = useRef<HTMLImageElement>(null);
    
    useEffect(() => {
        //img.current!.style.objectFit = "cover";
        //img.current!.style.width = "100%";
        //img.current!.style.height = "100%";
    }, [])
    
    const loadedImage = () => {
        setImageLoaded(true);
    }
    
    return(
        <React.Fragment>
            {!imgLoaded && <div className="skeleton"></div>}
            <img src={src} style={!imgLoaded? {display: "none"} : {}} className={className+(imgLoaded? " show-img" : "")} alt="" onLoad={loadedImage} onError={loadedImage} ref={img}/>
        </React.Fragment>
    )
}

export default Image;